import React from "react";
import {
  HvCard,
  HvCardHeader,
  HvCardContent,
} from "@hitachivantara/uikit-react-core";
import useStyles from "./styles";

export type DetailsKPIProps = {
  title: string;
  children: React.ReactNode;
};

const DetailsKPI: React.FC<DetailsKPIProps> = ({ title, children }) => {
  const classes = useStyles();

  return (
    <HvCard>
      <HvCardHeader
        title={title}
        classes={{
          root: classes.titleRoot,
          title: classes.titleText,
        }}
      />
      <HvCardContent className={classes.content}>{children}</HvCardContent>
    </HvCard>
  );
};
export default DetailsKPI;
